import { render, staticRenderFns } from "./storeMemberCategory.vue?vue&type=template&id=2864251a&scoped=true&"
import script from "./storeMemberCategory.vue?vue&type=script&lang=js&"
export * from "./storeMemberCategory.vue?vue&type=script&lang=js&"
import style0 from "./storeMemberCategory.vue?vue&type=style&index=0&id=2864251a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2864251a",
  null
  
)

export default component.exports